import React from 'react'
import Lottie from 'react-lottie'

import { compose, defaultProps, withProps } from 'recompose'

import animationDefault from './animation.json'
import animationWhite from './animationWhite.json'

type Props = {
  width?: number
  height?: number
  white?: boolean
}

type InnerProps = {
  options: {
    loop?: boolean
    autoplay?: boolean
    animationData: any
  }
} & Props

const enhance = compose<InnerProps, Props>(
  defaultProps({
    options: {
      loop: true,
      autoplay: true,
      animationData: animationDefault,
    },
    height: 100,
    width: 100,
  }),
  withProps<InnerProps & Props, Props>(({ width, height, white }) => {
    return {
      options: {
        animationData: white ? animationWhite : animationDefault,
      },
      height,
      width,
    }
  }),
)

export default enhance(({ options, height, width }) => (
  <Lottie options={options} width={width} height={height} />
))
